import * as Yup from 'yup';
import { useState } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import { networkGetToken } from '../../../network/auth';
import useToken from '../../../hooks/useToken';
import useAdminInfoStore from '../../../store/admin';
import { HOST_API } from '../../../config';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const uToken = useToken();
  const { setAdminInfo } = useAdminInfoStore();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const isMountedRef = useIsMountedRef();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    // email: Yup.string().email('آدرس ایمیل معتبر نیست').required('وارد کردن ایمیل ضروی است'),
    mobile: Yup.string().required('وارد کردن شماره موبایل ضروری است'),
    password: Yup.string().required('وارد کردن پسورد ضروری است'),
  });

  const defaultValues = {
    mobile: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      Mobile: values?.mobile,
      Password: values?.password,
    };

    try {
      const response = await networkGetToken(PAYLOAD);
      const responseData = response?.data?.items;

      if (responseData?.Menu?.length > 0) {
        const userInfo = await axios.post(`${HOST_API}authentication/Verify`);

        uToken.setToken(responseData?.TokenValue);
        setAdminInfo(responseData);

        enqueueSnackbar('شما با موفقیت وارد شدید');

        const defaultRoute = responseData?.Menu?.find((item) => item?.ProfileUACMenuIsDefaultRoute);
        navigate(defaultRoute?.ProfileUACMenuUrl);
        // navigate(PATH_DASHBOARD.general.projects);
      } else {
        enqueueSnackbar('شما دسترسی های لازم را ندارید', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('دیتای وارد شده صحیح نمیباشد', { variant: 'error' });
      // reset();
      if (isMountedRef.current) {
        setError('afterSubmit', { ...error, message: error.message });
      }
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3} sx={{ my: 2 }}>
        {/* {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>} */}

        <RHFTextField name="mobile" type="mobile" label="شماره موبایل" />

        <RHFTextField
          name="password"
          label="پسورد"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        ورود
      </LoadingButton>
    </FormProvider>
  );
}
